import React, { useState, useEffect } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Card,
    Container,
    CssBaseline,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormGroup,
    Grid,
    InputAdornment,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
    TextField,
    Typography,
    styled,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import httpclient from "../../utils";

const GridBlockContent = styled("div")(({ theme }) => ({
    display: "grid",
    maxWidth: "100%",
    gridTemplateColumns: "auto",
    gap: "1px solid #ccc",
    fontFamily: "'Trebechut' sans-serif",
    fontSize: "14px",
    fontWeight: "bold",
}));

const GridBlockTitle = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #f1f1f1",
    backgroundColor: "#f5f5f5",
    color: "#2a2a2a",
    padding: "16px",
    fontSize: "16px",
    textAlign: "left",
    textTransform: "uppercase",
}));

const Code = styled("div")(({ theme }) => ({
    width: "100px",
    fontSize: "20px",
}));
const Name = styled("div")(({ theme }) => ({
    width: "380px",
    fontSize: "20px",
}));
const FlexContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    fontSize: "17px",
    marginBottom: "10px",
    alignItems: "flex-start",
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "160px",
    //maxWidth: "320px",
    fontWeight: "600",
}));

const demoList = [
    {
        id: 1,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 2,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 3,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
    {
        id: 4,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 5,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 6,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
    {
        id: 7,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 8,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 9,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
];

const demoList1 = [
    {
        id: 11,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 12,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 13,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
    {
        id: 14,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 15,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 16,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
    {
        id: 17,
        school: "ABC School",
        salesID: "S001",
        ageing: 30,
        type: "Primary",
        mobile: "123-456-7890",
        email: "abc@example.com",
    },
    {
        id: 18,
        school: "XYZ School",
        salesID: "S002",
        ageing: 45,
        type: "Secondary",
        mobile: "987-654-3210",
        email: "xyz@example.com",
    },
    {
        id: 19,
        school: "123 School",
        salesID: "S003",
        ageing: 25,
        type: "High School",
        mobile: "555-555-5555",
        email: "123@example.com",
    },
];

const columns = [
    { field: "school", headerName: "School Name", width: 180 },
    { field: "salesID", headerName: "Sales ID", width: 120 },
    { field: "ageing", headerName: "Ageing", width: 100 },
    { field: "type", headerName: "Type", width: 150 },
    { field: "mobile", headerName: "Mobile Number", width: 180 },
    { field: "email", headerName: "Email Address", width: 200 },
];

const columnsSalesOrder = [
    { field: "salesid", headerName: "Sales ID", width: 140 },
    { field: "salesname", headerName: "Sales Name", width: 160 },
    { field: "sales_type", headerName: "Sales Type", width: 100 },
    { field: "document_status", headerName: "Document Status", width: 120 },
    { field: "inventlocationname", headerName: "Location", width: 160 },
    { field: "shipcarrierdeliverycontact", headerName: "Delivery Contact", width: 120 },
];

const ViewDialog = ({
    title,
    open,
    onClose,
    rows,
    columns,
    rowSelectionModel,
    setRowSelectionModel,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle sx={{ fontWeight: "600" }}>{title}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item md={12}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            disableRowSelectionOnClick
                            initialState={{
                                pagination: { paginationModel: { pageSize: 5 } },
                            }}
                            pageSizeOptions={[5, 10, 25]}
                            checkboxSelection
                            onRowSelectionModelChange={(newRowSelectionModel) => {
                                setRowSelectionModel(newRowSelectionModel);
                            }}
                            rowSelectionModel={rowSelectionModel}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const WarehouseOrdersNew = () => {
    const [rows, setRows] = useState([]);
    const [salesOrders, setSalesOrders] = useState([]);
    const [customerDetails, setCustomerDetails] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialog1, setOpenDialog1] = useState(false);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [rowSelectionModel1, setRowSelectionModel1] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [from, setFrom] = useState(1);
    const [to, setTo] = useState(20);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [total, setTotal] = useState("");

    //console.log("rowSelection", rowSelectionModel);
    //console.log("rowSelection11", rowSelectionModel1);

    const handleClickOpenDialog = (params) => {
        if (params.field === "__check__") {
            setOpenDialog(false);
        } else {
            setOpenDialog(true);
        }
    };

    const handleClickOpenDialog1 = (params) => {
        if (params.field === "__check__") {
            setOpenDialog1(false);
        } else {
            setOpenDialog1(true);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOpenDialog1(false);
    };

    useEffect(() => {
        // const rows1 = localStorage.getItem("costumer-list");
        // // const rows = JSON.parse(rows1);
        // if (rows1 != null) {
        //     setRows(JSON.parse(rows1));
        // }
        getAllCustomers();
        getSalesOrders();
    }, []);


    const getAllCustomers = () => {
        httpclient
            .get(
                `getCustomers`
            )
            .then(({ data }) => {
                if (data.status === 200) {
                    const rows = data.records.data;

                    setRows(rows);
                    //console.log("list!", rows);


                } else {
                    //console.log("Error!");
                }
            });
    };

    // const getSalesOrders = (newPage, newRowsPerPage) => {
    //     setLoading(true);
    //     httpclient
    //         .get(`getSalesOrders`, {
    //             params: {
    //                 page: newPage,
    //                 recordsOnPage: newRowsPerPage,
    //             },
    //         })
    //         .then(({ data }) => {
    //             if (data.status === 200) {
    //                 setSalesOrders(data.records.data);
    //                 setTotal(data.records.total);
    //                 setRowsPerPage(parseInt(data.records.per_page));
    //                 setPage(data.records.current_page);
    //                 setLoading(false);
    //             } else {
    //                 console.log('Error!');
    //             }
    //         });
    // };

    // useEffect(() => {
    //     getSalesOrders(page, rowsPerPage);
    // }, [page, rowsPerPage]);


    const getSalesOrders = () => {
        setLoading(true);
        httpclient
            .get(
                `getSalesOrders?version=v2&warehouseID=3R400&isPrinted=1&isReadyForCollection=0`
            )
            .then(({ data }) => {
                if (data.status === 200) {
                    setSalesOrders(data.records.data);
                    setTotal(data.records.total);
                    setRowsPerPage(parseInt(data.records.per_page));
                    setPage(data.records.current_page);
                    setFrom(data.records.from);
                    setTo(data.records.to);
                    setLoading(false);

                } else {
                    console.log("Error!");
                }
            });
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setCustomerDetails({
            ...customerDetails,
            [name]: value,
        });
    };

    const handleSearchFilter = (value) => {
        setCustomerDetails({
            ...customerDetails,
            name: value !== null ? value.name : "",
        });
    };
    const sortedOptions = React.useMemo(() => {
        const inputValue = customerDetails.name || "";

        const matchedInitialLetters = [];
        const remainingOptions = [];

        rows.forEach((option) => {
            const name = option.name || "";

            if (
                name &&
                name.toLowerCase().startsWith(inputValue.toLowerCase())
            ) {
                matchedInitialLetters.push(option);
            } else {
                remainingOptions.push(option);
            }
        });

        return [...matchedInitialLetters, ...remainingOptions];
    }, [customerDetails.name, rows]);

    return (
        <div>
            <Container
                component="main"
                maxWidth="xl"
                style={{ textAlign: "center", marginTop: "20px" }}
            >
                <CssBaseline />
                <Card>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormGroup>
                                <GridBlockContent>
                                    <GridBlockTitle>
                                        <Box
                                            p={2}
                                            pb={2}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <Code>3R100</Code>
                                            <Name>PSW Cheltanhem Retail Outlet</Name>
                                        </Box>
                                        <Box textAlign={"right"}>
                                            <Link to="">
                                                <Button color="error" variant="outlined">
                                                    <b>Exit</b>
                                                    <ArrowForward sx={{ marginRight: "10px" }} />
                                                </Button>
                                            </Link>
                                        </Box>
                                    </GridBlockTitle>
                                </GridBlockContent>
                            </FormGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={0.2}>
                        <Grid item md={6}>
                            <Card sx={{ background: "" }}>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={10}>
                                            <FlexContent>
                                                <FlexInnerTitle>
                                                    <span>Delivery Type</span>
                                                </FlexInnerTitle>

                                                <FormControl fullWidth size="small">
                                                    <Select
                                                        //value={}
                                                        //onChange={}
                                                        displayEmpty
                                                        inputProps={{ "aria-label": "Without label" }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Demo1</MenuItem>
                                                        <MenuItem value={20}>Demo2</MenuItem>
                                                        <MenuItem value={30}>Demo3</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </FlexContent>

                                            <FlexContent>
                                                <FlexInnerTitle>
                                                    <span>Customer</span>
                                                </FlexInnerTitle>

                                                {/* <FormControl fullWidth size="small"> */}
                                                <Autocomplete
                                                    disablePortal
                                                    inputValue={customerDetails.name}
                                                    //options={rows.length > 0 ? rows : []}
                                                    options={sortedOptions}
                                                    getOptionLabel={(option) => option.name || null}
                                                    renderOption={(props, option, index) => {
                                                        return (
                                                            <li {...props} key={option.id}>
                                                                {option.name}
                                                            </li>
                                                        );
                                                    }}
                                                    sx={{ width: "90%" }}
                                                    onChange={(event, newValue) => {
                                                        handleSearchFilter(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            size="small"
                                                            name="name"
                                                            value={customerDetails.name || ""}
                                                            onChange={handleChange}
                                                        />
                                                    )}
                                                />
                                                {/* </FormControl> */}
                                            </FlexContent>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Box textAlign="right">
                                                <Link to="">
                                                    <Button
                                                        size="medium"
                                                        variant="outlined"
                                                        color="primary"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: "10px",
                                                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        Reset Filter
                                                    </Button>
                                                </Link>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Card>

                            <Box
                                p={1}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                }}
                            >
                                <p style={{ fontWeight: "bold" }}>To be picked</p>
                                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                    <Select
                                        //value={}
                                        //onChange={}
                                        displayEmpty
                                        inputProps={{ "aria-label": "Without label" }}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value={10}>Demo1</MenuItem>
                                        <MenuItem value={20}>Demo2</MenuItem>
                                        <MenuItem value={30}>Demo3</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Grid item md={12}>
                                <DataGrid
                                    rows={salesOrders}
                                    columns={columnsSalesOrder}
                                    disableRowSelectionOnClick
                                    onCellClick={handleClickOpenDialog}
                                    checkboxSelection
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 10 } },
                                    }}
                                    pageSizeOptions={[10, 15, 20]}
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setRowSelectionModel(newRowSelectionModel);
                                    }}
                                    rowSelectionModel={rowSelectionModel}
                                    // rows={salesOrders}
                                    // columns={columnsSalesOrder}
                                    // disableRowSelectionOnClick
                                    // onCellClick={handleClickOpenDialog}
                                    // checkboxSelection
                                    // pagination
                                    // pageSize={rowsPerPage}
                                    // rowCount={total}
                                    // paginationMode="server"
                                    // onPageChange={(newPage) => setPage(newPage)}
                                    // onPageSizeChange={(pageSize) => setRowsPerPage(pageSize)}
                                    // loading={loading}
                                    // pageSizeOptions={[20, 50, 100]}
                                    // onRowSelectionModelChange={(newRowSelectionModel) => {
                                    //     setRowSelectionModel(newRowSelectionModel);
                                    // }}
                                    // rowSelectionModel={rowSelectionModel}
                                />
                                {openDialog && (
                                    <ViewDialog
                                        title={"To be picked"}
                                        open={openDialog}
                                        onClose={handleCloseDialog}
                                        rows={salesOrders}
                                        columns={columnsSalesOrder}
                                        rowSelectionModel={rowSelectionModel}
                                        setRowSelectionModel={setRowSelectionModel}
                                    />
                                )}
                            </Grid>
                        </Grid>
                        <Grid item md={6}>
                            <Card>
                                <Box
                                    p={1}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <p style={{ fontWeight: "bold" }}>Preparing Order</p>
                                </Box>
                            </Card>
                            <Grid container spacing={0}>
                                <Grid item md={2}>
                                    <Box>
                                        <Link to="">
                                            <Button
                                                size="medium"
                                                variant="outlined"
                                                color="success"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Print PS Label
                                            </Button>
                                        </Link>
                                    </Box>
                                    <Box>
                                        <Link to="">
                                            <Button
                                                size="medium"
                                                variant="outlined"
                                                color="success"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                    fontSize: "12px",
                                                }}
                                            >                                         
                                                Print Order
                                            </Button>
                                        </Link>
                                    </Box>
                                    {/* <Box textAlign="left">
                                        <Link to="">
                                            <Button
                                                size="large"
                                                variant="outlined"
                                                color="warning"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: '10px',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                View Order
                                            </Button>
                                        </Link>
                                    </Box> */}
                                    <Box>
                                        <Link to="">
                                            <Button
                                                size="medium"
                                                variant="outlined"
                                                color="error"
                                                sx={{
                                                    margin: "10px",
                                                    borderRadius: "10px",
                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Unpick Order
                                            </Button>
                                        </Link>
                                    </Box>
                                </Grid>
                                <Grid item md={10}>
                                    <DataGrid
                                        rows={salesOrders}
                                        columns={columnsSalesOrder}
                                        disableRowSelectionOnClick
                                        onCellClick={handleClickOpenDialog1}
                                        checkboxSelection
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 10 } },
                                        }}
                                        pageSizeOptions={[10, 15, 20]}
                                        onRowSelectionModelChange={(newRowSelectionModel1) => {
                                            setRowSelectionModel1(newRowSelectionModel1);
                                        }}
                                        rowSelectionModel={rowSelectionModel1}
                                    />
                                    {openDialog1 && (
                                        <ViewDialog
                                            title={"Preparing Order"}
                                            open={openDialog1}
                                            onClose={handleCloseDialog}
                                            rows={salesOrders}
                                            columns={columnsSalesOrder}
                                            rowSelectionModel={rowSelectionModel1}
                                            setRowSelectionModel={setRowSelectionModel1}
                                        />
                                    )}
                                </Grid>
                                <Grid item md={12}>
                                    <Card
                                        sx={{
                                            background: "#f5f5f5",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <Box>
                                            <Link to="">
                                                <Button
                                                    size="medium"
                                                    variant="outlined"
                                                    color="warning"
                                                    sx={{
                                                        margin: "10px",
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    Partial order Picked
                                                </Button>
                                            </Link>
                                        </Box>
                                        <Box>
                                            <TextField sx={{ width: "300px" }} />
                                        </Box>
                                        <Box>
                                            <Link to="">
                                                <Button
                                                    size="medium"
                                                    variant="outlined"
                                                    color="success"
                                                    sx={{
                                                        margin: "10px",
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    Invoice Order In Full
                                                </Button>
                                            </Link>
                                        </Box>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}></Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={0}>
                        <Box
                            p={1}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                            }}
                        >
                            <p style={{ fontWeight: "bold" }}>Ready for collection</p>
                        </Box>
                        <Grid item md={12}>
                            <DataGrid
                                rows={salesOrders}
                                columns={columnsSalesOrder}
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 10 } },
                                }}
                                pageSizeOptions={[10, 15, 20]}
                                checkboxSelection
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormGroup>
                                <GridBlockContent>
                                    <GridBlockTitle>
                                        <Box
                                            pb={2}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <Box>
                                                <Link to="">
                                                    <Button
                                                        size="large"
                                                        variant="outlined"
                                                        color="error"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: "10px",
                                                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                        }}
                                                    >
                                                        Push Back To Pick
                                                    </Button>
                                                </Link>
                                            </Box>
                                            <Box>
                                                <TextField sx={{ width: "300px" }} />
                                            </Box>
                                            <Box>
                                                <TextField sx={{ width: "300px" }} />
                                            </Box>
                                            <Box>
                                                <Link to="">
                                                    <Button
                                                        size="large"
                                                        variant="outlined"
                                                        color="success"
                                                        sx={{
                                                            margin: "10px",
                                                            borderRadius: "10px",
                                                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                                        }}
                                                    >
                                                        Order Collected
                                                    </Button>
                                                </Link>
                                            </Box>
                                        </Box>
                                        <Box textAlign={"right"}>
                                            <Link to="">
                                                <Button
                                                    sx={{ background: "#888888" }}
                                                    variant="outlined"
                                                >
                                                    <b>Query History</b>
                                                </Button>
                                            </Link>
                                        </Box>
                                    </GridBlockTitle>
                                </GridBlockContent>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </div>
    );
};

export default WarehouseOrdersNew;
